module.exports = __webpack_public_path__ + "static/img/revolution.4a0f866.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/generate/revolution.png
// module id = Oz03
// module chunks = 1